module.exports = __webpack_public_path__ + "static/img/entrance.6566cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/selfMadeGame/entrance.png
// module id = uZHQ
// module chunks = 0